// extracted by mini-css-extract-plugin
export default {"returnButton":"alertDetails_returnButton__iVj4j","alertDetails":"alertDetails_alertDetails__7tnLN","vitalReading":"alertDetails_vitalReading__ULYVA"};